import React, { useEffect, useRef } from 'react';
import ItemLink from './common/ItemLink';
import { getEntityPath } from '../utils/entityPath';

function NavigationBar({ navLista, handleNavLista }: { navLista: any; handleNavLista: any }) {
	const containerRef = useRef<any>(null);
	const selectedItemRef = useRef<any>(null);
	useEffect(() => {
		if (selectedItemRef.current && containerRef.current) {
			selectedItemRef.current.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'center',
			});
		}
	}, [navLista.length]);
	return (
		<div ref={containerRef} className='snap-x snap-mandatory w-full h-9 bg-gradient-to-b from-blueDark via-blueLight to-blueDark flex flex-row items-center px-8 overflow-x-auto  no-scroll'>
			<ItemLink
				className={`${navLista?.length === 0 ? 'text-gold' : 'text-white hover:text-gold'} font-medium text-[16px] leading-5 cursor-pointer hover:underline `}
				href='/home'
				onActivate={() => handleNavLista(null)}
			>
				Kategorije
			</ItemLink>
			{navLista?.map((item: any, index: number) => (
				<div className='flex flex-row items-center' key={index} ref={index + 1 === navLista.length ? selectedItemRef : null}>
					<div className='text-white font-medium text-[18px] leading-5 mx-2'>{'>'}</div>
					<ItemLink
						className={`${
							index + 1 === navLista?.length ? 'text-gold' : 'text-white hover:text-gold'
						} whitespace-nowrap font-medium text-[16px] leading-5 cursor-pointer hover:underline tracking-tight`}
						key={index}
						href={getEntityPath(item)}
						onActivate={() => handleNavLista(item)}
					>
						{item.naziv}
					</ItemLink>
				</div>
			))}
		</div>
	);
}

export default NavigationBar;
